import type { NavigateOptions } from "react-router-dom";

// Simple global navigate registrar to bridge non-hook contexts and tests
type NavigateFunction = (to: string, options?: NavigateOptions) => void;

let globalNavigate: NavigateFunction | null = null;

export const registerNavigate = (navigateFn: NavigateFunction): void => {
  globalNavigate = navigateFn;
};

export const navigate: NavigateFunction = (to, options) => {
  if (globalNavigate) {
    globalNavigate(to, options);
  } else {
    // Fallback: update history so Reach or other listeners can react
    const replace = options && "replace" in options ? options.replace : false;
    if (replace) {
      window.history.replaceState({}, "", to);
      window.dispatchEvent(new PopStateEvent("popstate"));
    } else {
      window.history.pushState({}, "", to);
      window.dispatchEvent(new PopStateEvent("popstate"));
    }
  }
};


